module.exports = __webpack_public_path__ + "img/bearing-icon.5874632d.svg";